@let it = client();
<mat-toolbar>
  <h1>Client Account</h1>
  <span class="spacer"></span>
  <div class="cell-actions">
    <button matMiniFab (click)="back()" matTooltip="Go back">
      <mat-icon>reply</mat-icon>
    </button>

    @if (it) {
      <button matIconButton matTooltip="Products" [routerLink]="['/app/products', it.ClientCode]">
        <mat-icon>shopping_bag</mat-icon>
      </button>
      <button matIconButton matTooltip="Agreements" [routerLink]="['/app/agreements', it.ClientCode]">
        <mat-icon>assignment</mat-icon>
      </button>
    }

    <a matIconButton matTooltip="Open Knowledge Doc" target="_blank" [href]="kbLink">
      <mat-icon>menu_book</mat-icon>
    </a>
  </div>
</mat-toolbar>

@if (it) {
  <div class="grid">
    <div class="c-12 c-lg-8">
      <section>
        <mat-toolbar>
          <h2>{{ it.ClientName }}</h2>
          <span class="spacer"></span>
          @if (canEdit) {
            <button matMiniFab (click)="edit()" [disabled]="pending()">
              <mat-icon>edit</mat-icon>
            </button>
          }
        </mat-toolbar>

        <!-- this element is required to load table CSS. When angular material add better way to render static tables,
      feel free to drop it. Or just render details as a list. -->
        <table mat-table style="display: none">
          <tr mat-header-row *matHeaderRowDef="[]"></tr>
          <tr mat-row *matRowDef="let row; columns: []"></tr>
        </table>

        <table class="mat-mdc-table">
          <tbody>
            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell mdc-data-table__header-cell">Client Code</th>
              <td class="mat-mdc-cell mdc-data-table__cell">{{ it.ClientCode }}</td>
            </tr>

            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell mdc-data-table__header-cell">Client Name</th>
              <td class="mat-mdc-cell mdc-data-table__cell">{{ it.ClientName }}</td>
            </tr>

            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell mdc-data-table__header-cell">Xero ID</th>
              <td class="mat-mdc-cell mdc-data-table__cell">
                <a
                  href="https://go.xero.com/Contacts/View.aspx?contactID={{ it.XeroId }}"
                  target="_blank"
                  title="{{ it.XeroId }}"
                >
                  {{ it.XeroId }}
                </a>
              </td>
            </tr>

            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell mdc-data-table__header-cell">Insightly ID</th>
              <td class="mat-mdc-cell mdc-data-table__cell">
                <a
                  href="https://googleapps.insight.ly/details/Organisations/Details/{{ it.InsightlyId }}"
                  target="_blank"
                  title="{{ it.InsightlyId }}"
                >
                  {{ it.InsightlyId }}
                </a>
              </td>
            </tr>

            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell mdc-data-table__header-cell">AWS ID</th>
              <td class="mat-mdc-cell mdc-data-table__cell">{{ it.AwsId }}</td>
            </tr>

            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell mdc-data-table__header-cell">Commissionable</th>
              <td class="mat-mdc-cell mdc-data-table__cell">{{ it.Commissionable ? 'Yes' : 'No' }}</td>
            </tr>

            <tr class="mat-mdc-row">
              <th class="mat-mdc-header-cell mdc-data-table__header-cell">Notes</th>
              <td class="mat-mdc-cell mdc-data-table__cell">{{ it.Notes }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <div class="c-12 c-lg-4">
      <lcm-activity-stream [id]="'client' + it.ClientCode" />
    </div>
  </div>
} @else {
  <mat-spinner></mat-spinner>
}
